import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Menu } from "@material-ui/icons";
import { connect } from "react-redux";
import { ConfirmLogout } from "../../Components/Alert/alert.component";

import { toggleDrawerHidden } from "../../Redux/Drawer/drawer.actions";
import "./header.styles.scss";

const Header = ({
  SideNav,
  toggleDrawerHidden,
  fromContact,
  currentUser,
  history,
}) => {
  return (
    <div className="header">
      {SideNav ? (
        <Menu
          style={{ color: "white", marginLeft: 20, marginTop: 25 }}
          onClick={() => toggleDrawerHidden()}
        />
      ) : null}
      <h1 className="title">
        {SideNav
          ? "Assessment Portal"
          : fromContact
          ? "Can't Find The Way In?"
          : "TBS OPEN ASSESSMENT"}
        <br />
      </h1>
      {SideNav || fromContact ? null : (
        <div className="options">
          <Link className="option" style={{ color: "yellow" }} to="/About-Us">
            ABOUT
          </Link>
          <p style={{ color: "yellow", position: "relative", top: 22 }}>|</p>
          <Link className="option" style={{ color: "yellow" }} to="/Contact-Us">
            CONTACT
          </Link>
          <p style={{ color: "yellow", position: "relative", top: 22 }}>|</p>
          {currentUser ? (
            <div
              className="option"
              style={{ color: "yellow", cursor: "pointer" }}
              onClick={() => ConfirmLogout(history)}
            >
              LOGOUT
            </div>
          ) : (
            <Link className="option" to="/" style={{ color: "yellow" }}>
              SIGN IN
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ user: { currentUser } }) => ({
  currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  toggleDrawerHidden: () => dispatch(toggleDrawerHidden()),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
